// Figma "Final Final"'s colour variables, named after their labels; onboarding keeps its own in public/themes/onboarding.css.
export const palette = {
  container: '#ffffff',
  background: '#ededed',
  type: '#414042',
  green: '#d2ffdf',
  purple: '#5b1bf5',
  'grey-mid': '#d9d9d9',
  red: '#ec4a5d',

  // Figma's unlabelled colours
  white: '#ffffff',
  black: '#000000',
  teal: '#004053',
  'grey-dark': '#666666',
  // The one colour outside Figma's set: warnings need an amber, pending the designer.
  amber: '#ffe56c',
} as const;

export type PaletteName = keyof typeof palette;
